import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, Ref } from 'vue';
import ChatgroupDefaultAvatar from '@/components/svg/chatgroup-default-avatar.svg?inline';
import BCXAvatar from '@/components/molecules/BCXAvatar.vue';
import { ChatGroup } from '@/models/Messenger';
import { User } from '@/models/User';
import useMessengerState from '@/state/messenger/messengerState';
import userFromState from '@/state/messenger/userFromState';
import useFormattedDateTime, { TimeFormatting } from '@/mixins/useFormattedDateTime';
import useI18n from '@/mixins/useI18n';
import stripTags from '@/utils/stripTags';
import { getDisplayName } from '@/utils/user';
import { createVuexHelpers } from 'vue2-helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXMessengerChatGroupPreview',
  props: {
  group: {
    type: Object as PropType<ChatGroup>,
    required: true
  },
  isFlat: Boolean
},
  setup(__props) {

const props = __props;



const {
  selectChat, isExpanded, selectedChatId, groupLastMessages, perGroupMeta, isMarkingChats
} = useMessengerState();
const { getFormattedTimeByAge } = useFormattedDateTime();
const i18n = useI18n();
const { useGetters } = createVuexHelpers();
const { user } = useGetters(['user']) as { user: Ref<User> };

// Chat groups can't be cleaned up, and opening one marks it read — so ignore clicks while marking instead of silently dropping the unread state.
const open = () => {
  if (!isMarkingChats.value) selectChat(props.group.groupId);
};

const isSelected = computed(() => selectedChatId.value === props.group.groupId);
const memberCount = computed(() => props.group.memberCount);
const unreadCount = computed(() => perGroupMeta.value[props.group.groupId]?.unreadCount ?? 0);

const lastMessage = computed(() => groupLastMessages.value[props.group.groupId]);
const lastSenderId = computed(() => lastMessage.value?.creator ?? '');
const lastText = computed(() => stripTags(lastMessage.value?.text ?? ''));
const lastMessageDate = computed(() => (lastMessage.value
  ? getFormattedTimeByAge(lastMessage.value.created, TimeFormatting.ChatMessageOverview) : ''));
const senderLabel = computed(() => {
  const creator = lastMessage.value?.creator;
  if (!creator) return '';
  return user.value?.userId === creator ? i18n.t('messenger.chat.me') : getDisplayName(userFromState(creator));
});

return { __sfc: true,props, selectChat, isExpanded, selectedChatId, groupLastMessages, perGroupMeta, isMarkingChats, getFormattedTimeByAge, i18n, useGetters, user, open, isSelected, memberCount, unreadCount, lastMessage, lastSenderId, lastText, lastMessageDate, senderLabel, ChatgroupDefaultAvatar, BCXAvatar }
}

})